import React from "react";
import moment from "moment";

const MANUAL_COLOR = "#b45309";

// Small pencil next to a calendar day number — the day's attendance was
// entered by a super-admin by hand (no selfie). Hover shows the remarks.
export const ManualMark = ({ entry, fontSize = 9 }) =>
  entry ? (
    <span
      title={`Marked manually — ${entry.remarks}`}
      style={{ marginLeft: 3, fontSize, fontWeight: 700, color: MANUAL_COLOR }}
    >
      ✎
    </span>
  ) : null;

// Day-detail block: who marked the day manually, when, and why.
const ManualEntryNote = ({ entry }) =>
  entry ? (
    <div
      className="mt-2 small"
      style={{
        background: "#fef3c7",
        borderLeft: `3px solid ${MANUAL_COLOR}`,
        borderRadius: 4,
        padding: "8px 10px",
        color: "#3e4954",
      }}
    >
      <strong style={{ color: MANUAL_COLOR }}>✎ Marked manually</strong>
      {entry.markedBy ? ` by ${entry.markedBy}` : ""}
      {entry.markedAt
        ? ` on ${moment(entry.markedAt).format("DD MMM YYYY, HH:mm")}`
        : ""}
      <div style={{ whiteSpace: "pre-wrap" }}>
        <strong>Remarks:</strong> {entry.remarks}
      </div>
    </div>
  ) : null;

export default ManualEntryNote;
